const getButtonsLabels = (appointment, showForm, labels) => {
  if (!appointment || "durationInMinutes" in appointment) {
    return {
      save: showForm ? labels.buttons.save : labels.buttons.schedule ?? "",
      cancel: showForm ? labels.buttons.cancel : labels.buttons.deleteAppointment
    };
  }
  return {
    save: (
      // eslint-disable-next-line no-nested-ternary
      appointment && (appointment == null ? void 0 : appointment.cancellationType) ? labels.buttons.deleteAppointment : showForm ? labels.buttons.save : labels.buttons.edit
    ),
    cancel: showForm ? labels.buttons.cancel : labels.buttons.cancelAppointment
  };
};
export {
  getButtonsLabels
};
